export const Intent = {
  UNSOLICITED: 0,
  REQUESTED: 1,
  PROVIDED: 2,
};

export const MessageSender = {
  SYSTEM: 0,
  CLERK: 1,
  INSTALLATEUR: 2,
};

export const Entity = {
  INSTALLER: 0,
  SPECIALIST: 1,
  SEALING: 2,
};

const MESSAGE_SENDER_LABELS = {
  [MessageSender.SYSTEM]: 'System',
  [MessageSender.CLERK]: 'Sachbearbeiter',
  [MessageSender.INSTALLATEUR]: 'Installateur',
};

const ENTITY_LABELS = {
  [Entity.INSTALLER]: 'Installateur',
  [Entity.SPECIALIST]: 'Fachkraft',
  [Entity.SEALING]: 'Plombierung',
};

export const getMessageSenderLabel = (value) =>
  MESSAGE_SENDER_LABELS[value] ?? 'Unbekannt';

export const getEntityLabel = (value) => ENTITY_LABELS[value] ?? 'Unbekannt';
